import { render } from "./EnglishTest.vue?vue&type=template&id=4a664398&scoped=true"
import script from "./EnglishTest.vue?vue&type=script&lang=js"
export * from "./EnglishTest.vue?vue&type=script&lang=js"

import "./EnglishTest.vue?vue&type=style&index=0&id=4a664398&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\Ned-ie\\ned_website-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a664398"]])

export default __exports__